<template>
  <div
    class="xxl:fixed mt-8 mb-8 mx-4 xxl:mx-0 xxl:my-0 top-0 left-0 w-full min-w-full h-full min-h-full xxl:overflow-y-scroll"
  >
    <transition name="fade">
      <div class="flex justify-center items-center w-full min-w-full h-full min-h-full">
        <div class="flex bg-white max-w-6xl w-full shadow-lg overflow-hidden items-stretch">
          <div
            class="w-6/12 bg-center bg-cover"
            style="background-image: url('https://tools.playmore.golf/Compare/img/bg4.jpg')"
          />

          <div class="w-6/12 p-8 pl-9 pr-9">
            <div>
              <div class="text-2xl font-bold text-gray-800 heading leading-none">
                Flexible Membership Profit Simulator
              </div>
              <div class="text-sm text-gray-500 mt-2 leading-relaxed">
                <!-- Enter a subtitle here -->
              </div>
            </div>

            <div class="mt-6">
              <div class="text-sm text-gray-700 font-semibold mt-2 leading-relaxed mb-1">
                Club name
              </div>
              <div class="bg-gray-100 text-base pl-3 pr-3 p-2">
                <input
                  v-model="clubName"
                  class="bg-transparent outline-none w-full min-w-full"
                />
              </div>
            </div>

            <div v-if="contactDetailsRequired">
              <div class="mt-4 flex">
                <div class="w-1/2 mr-2">
                  <div class="text-sm text-gray-700 font-semibold mt-2 leading-relaxed mb-1">
                    First name
                  </div>
                  <div class="bg-gray-100 text-base pl-3 pr-3 p-2">
                    <input
                      v-model="firstName"
                      class="bg-transparent outline-none w-full min-w-full"
                    />
                  </div>
                </div>

                <div class="w-1/2 ml-2">
                  <div class="text-sm text-gray-700 font-semibold mt-2 leading-relaxed mb-1">
                    Last name
                  </div>
                  <div class="bg-gray-100 text-base pl-3 pr-3 p-2">
                    <input
                      v-model="lastName"
                      class="bg-transparent outline-none w-full min-w-full"
                    />
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div class="text-sm text-gray-700 font-semibold mt-2 leading-relaxed mb-1">
                  Email address
                </div>
                <div class="bg-gray-100 text-base pl-3 pr-3 p-2">
                  <input
                    v-model="email"
                    class="bg-transparent outline-none w-full min-w-full"
                  />
                </div>
              </div>

              <div class="mt-4">
                <div class="text-sm text-gray-700 font-semibold mt-2 leading-relaxed mb-1">
                  Phone number
                </div>
                <div class="bg-gray-100 text-base pl-3 pr-3 p-2">
                  <input
                    v-model="phoneNumber"
                    class="bg-transparent outline-none w-full min-w-full"
                  />
                </div>
              </div>
            </div>

            <div class="mt-4">
              <div class="text-sm text-gray-700 font-semibold mt-2 leading-relaxed mb-1">
                Do you currently have a flexible membership category at your club?
              </div>

              <div class="flex items-center">
                <div class="flex items-center">
                  <div
                    class="bg-white hover:bg-gray-100 transition-all duration-500 border w-4 h-4 leading-none cursor-pointer flex justify-center items-center"
                    @click="existingFlexibleMembership = false"
                  >
                    <i
                      class="fas text-xs text-gray-600 fa-check"
                      :class="!existingFlexibleMembership ? '' : 'opacity-0'"
                      style="margin-top: 2px"
                    />
                  </div>
                  <div class="ml-2 text-sm leading-none">
                    No
                  </div>
                </div>

                <div class="flex ml-4 items-center">
                  <div
                    class="bg-white hover:bg-gray-100 transition-all duration-500 border w-4 h-4 leading-none cursor-pointer flex justify-center items-center"
                    @click="existingFlexibleMembership = true"
                  >
                    <i
                      class="fas text-xs text-gray-600 fa-check"
                      :class="existingFlexibleMembership ? '' : 'opacity-0'"
                      style="margin-top: 2px"
                    />
                  </div>
                  <div class="ml-2 text-sm leading-none">
                    Yes
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="error"
              class="text-sm text-red-500 -mb-4 mt-6"
            >
              Sorry, there was a problem with the details you entered. Please ensure all details are
              valid.
            </div>

            <div
              v-if="invalidEmail"
              class="text-sm text-red-500 -mb-4 mt-6"
            >
              Sorry, the email you provided was invalid. Please try another.
            </div>

            <div class="mt-8">
              <div
                class="w-full min-w-full text-sm font-medium p-4 text-center transition-all duration-500 text-white select-none uppercase border leading-none mt-2"
                :class="
                  isValid
                    ? 'bg-secondary-100 hover:bg-secondary-200 border-secondary-100 cursor-pointer'
                    : 'bg-gray-300 text-gray-700 cursor-default'
                "
                @click="submit()"
              >
                Continue to the membership simulator
              </div>
            </div>

            <div
              v-if="contactDetailsRequired"
              class="text-xs text-center text-gray-500 mt-4"
            >
              PlayMoreGolf needs this information to contact you about our products and services.
              You may unsubscribe from these communications at any time. For information on how to
              unsubscribe, as well as our privacy practices and commitment to protecting your
              privacy, please review our Privacy Policy.
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { submitProspectFormContact } from '@/app/shared/services/hubspotService/hubspotService';
  import { discover } from '@/app/shared/services/prospectService/prospectService';

  export default {
    name: 'ClubProspectForm',

    components: {},

    data() {
      return {
        clubName: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',

        existingFlexibleMembership: false,
        contactDetailsRequired: true,
        error: false,
        invalidEmail: false,
        userDiscovery: null,
      };
    },

    computed: {
      isValid() {
        if (
          (this.clubName !== ''
            && this.firstName !== ''
            && this.lastName !== ''
            && this.phoneNumber !== ''
            && this.email !== '')
          || (this.clubName !== '' && !this.contactDetailsRequired)
        ) {
          return true;
        }
      },
    },

    mounted() {
      discover().then((result) => {
        if (this.getHubspotCookie() !== null && result.data.email !== null) {
          this.contactDetailsRequired = false;
          this.userDiscovery = result.data;
        }
      });

      const { query } = this.$route;
      if (query.contactDetailsRequired !== undefined) {
        this.contactDetailsRequired = !(query.contactDetailsRequired === 'false');
      }
    },

    methods: {
      getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      },

      submit() {
        if (this.isValid) {
          if (this.contactDetailsRequired || this.userDiscovery !== null) {
            if (this.userDiscovery !== null) {
              this.email = this.userDiscovery.EmailAddress;
              this.firstName = this.userDiscovery.Forename;
              this.lastName = this.userDiscovery.Surname;
            }

            const vm = this;
            try {
              submitProspectFormContact(
                this.getHubspotCookie(),
                this.email,
                this.firstName,
                this.lastName,
                this.phoneNumber,
                this.clubName,
                this.existingFlexibleMembership
              )
                .then((data) => {
                  if (data.status === 'error') {
                    this.error = true;
                  } else {
                    // this.$router.push(?user=${this.email}`);
                    this.$router.push({
                      name: 'ClubProspect',
                      params: {
                        clubName: this.clubName,
                        existingFlexibleMembership: this.existingFlexibleMembership,
                        emailAddress: this.email,
                      },
                    });
                  }
                  // eslint-disable-next-line func-names
                })
                .catch(() => {
                  vm.error = true;
                });
            } catch (err) {
              vm.error = true;
            }
          } else {
            let route = `/Prospect/${this.clubName}/${this.existingFlexibleMembership}`;

            if (
              this.$route.query.compareOwnFlexi === true
              || this.$route.query.compareOwnFlexi === 'true'
            ) {
              route += '/true';
            }

            this.$router.push(route);
          }
        }
      },

      getHubspotCookie() {
        let hutkId;
        const value = `; ${document.cookie}`;
        const parts = value.split('; ' + 'hubspotutk' + '=');
        if (parts.length === 2) {
          return (hutkId = parts.pop().split(';').shift());
        }
        return null;
      },
    },
  };
</script>
<style src="../assets/site.css"></style>
